'use client';

// Adapted from T3 Code's useEnvironmentDisconnectDelay.ts (MIT, Copyright 2026 T3 Tools Inc.),
// commit 0ae1091d019484d474fce0fe0a89195a82134041.
// Full notice: public/third-party-licenses.txt.
import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';

/** How long a session's live feed may be down before the page says so. */
export const CONNECTION_GRACE_MS = 15_000;

/**
 * Whether the feed of `disconnectedSessionId` has been down for `CONNECTION_GRACE_MS` without a
 * break, so brief outages pass unseen. Pass null while the feed is live; another session waits
 * the whole grace again.
 */
export function useDisconnectDelay(disconnectedSessionId) {
  const $ = _c(5);
  let t0;
  if ($[0] !== disconnectedSessionId) {
    t0 = {
      sessionId: disconnectedSessionId,
      elapsed: false
    };
    $[0] = disconnectedSessionId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const [delay, setDelay] = useState(t0);
  if (delay.sessionId !== disconnectedSessionId) {
    setDelay({
      sessionId: disconnectedSessionId,
      elapsed: false
    });
  }
  let t1;
  let t2;
  if ($[2] !== disconnectedSessionId) {
    t1 = () => {
      if (disconnectedSessionId === null) {
        return;
      }
      const timeout = setTimeout(() => setDelay({
        sessionId: disconnectedSessionId,
        elapsed: true
      }), CONNECTION_GRACE_MS);
      return () => clearTimeout(timeout);
    };
    t2 = [disconnectedSessionId];
    $[2] = disconnectedSessionId;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  return disconnectedSessionId !== null && delay.sessionId === disconnectedSessionId && delay.elapsed;
}